import s from './errorShowComponent.module.scss';

const ErrorShowComponent = ({ errorProp, touchedProp, mustTouched = true }) => {
  return mustTouched
    ? (touchedProp && errorProp && (
        <p className={s.addTaskFormError}>{errorProp}</p>
      )) ||
        null
    : (errorProp && <p className={s.addTaskFormError}>{errorProp}</p>) || null;
};

export default ErrorShowComponent;
